import { useSelector } from 'react-redux'
import { useEffectOnce } from '@chilecompra/react-kit'
import { Spinner } from '@chilecompra/react-kit/components'

import { Root } from './UniquePassAuth.styles'

/**
 * The UniquePassAuth's container.
 */
const UniquePassAuth = () => {
  const hash = new URLSearchParams(window.location.hash.substring(1))
  const hashCode = hash.get('code')
  const hashState = hash.get('session_state')

  const { loading } = useSelector(state => state.uniquePassAuth)

  useEffectOnce(() => {
    if (hashCode && hashState) {
      const message = {
        data: {
          hashCode,
          hashState
        },
        type: 'AUTH_CALLBACK'
      }

      localStorage.setItem(
        'auth_callback_data',
        JSON.stringify({
          timestamp: Date.now(),
          ...message
        })
      )
      setTimeout(() => window.close(), 1000)
    }
  })

  if (loading) {
    return (
      <Root>
        <Spinner />
      </Root>
    )
  }

  return null
}

export default UniquePassAuth
